import React from 'react';
import { Button, Card, Stack, Flex, spacing, useTheme } from '@fti/design-system';
import type { ImportSessionStatus } from '../../types/dataset';

interface UploadProgressProps {
  filename: string;
  progress: number;
  status: ImportSessionStatus;
  onCancel: () => void;
}

export const UploadProgress: React.FC<UploadProgressProps> = ({
  filename,
  progress,
  status,
  onCancel,
}) => {
  const { theme } = useTheme();

  const statusLabel = status === 'uploading'
    ? 'Uploading...'
    : status === 'parsing'
    ? 'Parsing...'
    : 'Processing...';

  return (
    <Card variant="elevated">
      <Card.Body>
        <Stack gap="md">
          <Flex justify="between" align="center">
            <div>
              <p
                style={{
                  margin: 0,
                  fontWeight: 600,
                  fontSize: '1rem',
                  color: theme.colors.text.primary,
                }}
              >
                {statusLabel}
              </p>
              <p
                style={{
                  margin: 0,
                  marginTop: spacing.xs,
                  fontSize: '0.85rem',
                  color: theme.colors.text.secondary,
                }}
              >
                {filename}
              </p>
            </div>
            <Button variant="outline" color="neutral" size="sm" onClick={onCancel}>
              Cancel
            </Button>
          </Flex>

          {/* Progress bar */}
          <div
            style={{
              width: '100%',
              height: '8px',
              borderRadius: '4px',
              backgroundColor: theme.colors.background.paper,
              overflow: 'hidden',
            }}
          >
            <div
              style={{
                width: `${Math.min(progress, 100)}%`,
                height: '100%',
                borderRadius: '4px',
                backgroundColor: theme.colors.primary[500],
                transition: 'width 0.3s ease',
              }}
            />
          </div>

          <p
            style={{
              margin: 0,
              fontSize: '0.85rem',
              color: theme.colors.text.secondary,
              textAlign: 'center',
            }}
          >
            {progress}%
          </p>
        </Stack>
      </Card.Body>
    </Card>
  );
};
